import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Gamepad2 } from 'lucide-react';

export const OriginalsSectionHeader = ({ collapsed, active, expanded, onToggle, onNavigate, testIdPrefix }) => {
  const linkProps = {
    to: '/originals',
    onClick: onNavigate,
    title: 'Originals',
    'aria-label': 'Originals',
    'aria-current': active ? 'page' : undefined,
    'data-testid': `${testIdPrefix}-link-originals`,
  };

  if (collapsed) return (
    <Link {...linkProps} className={`flex justify-center rounded-xl py-2.5 mt-3 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-400 ${active ? 'bg-emerald-500/15 text-emerald-300 ring-1 ring-emerald-400/25' : 'text-slate-400 hover:bg-white/5 hover:text-white'}`}>
      <Gamepad2 className="h-5 w-5" aria-hidden="true" />
    </Link>
  );

  return (
    <div className={`sidebar-originals-heading flex items-center rounded-lg transition-colors ${active ? 'bg-emerald-500/15' : ''}`}>
      <Link {...linkProps} className={`flex min-w-0 flex-1 items-center gap-2 rounded-lg px-3.5 py-3 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-400 ${active ? 'text-emerald-300' : 'text-slate-500 hover:text-slate-300 hover:bg-white/5'}`}>
        <Gamepad2 size={16} aria-hidden="true" /><span className="text-[11px] font-semibold uppercase tracking-[0.18em]" data-testid={`${testIdPrefix}-section-games-label`}>Originals</span>
      </Link>
      <button type="button" onClick={onToggle} aria-label={`${expanded ? 'Collapse' : 'Expand'} Originals games`}
        aria-expanded={expanded} aria-controls={`${testIdPrefix}-originals-games`}
        data-testid={`${testIdPrefix}-section-games`}
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-white/5 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-400">
        <ChevronDown aria-hidden="true" className={`h-3.5 w-3.5 transition-transform duration-200 ${expanded ? '' : '-rotate-90'}`} />
      </button>
    </div>
  );
};